import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .admin-dashboard-page {
    .dashboard-area {
      padding: 70px 0;
    }

    .dashboard-card {
      background: #fff;
      border: 1px solid ${colors.border1};
      border-radius: 12px;
      box-shadow: 0 12px 40px rgba(15, 35, 67, 0.08);
      padding: 30px;
      min-height: 320px;
    }

    .dashboard-content {
      display: flex;
      flex-direction: column;
      gap: 32px;
    }

    .summary-cards {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
      gap: 20px;
      align-content: flex-start;
      justify-content: flex-start;
    }

    .summary-card {
      border-radius: 12px;
      padding: 24px;
      background: linear-gradient(140deg, ${colors.red_bg}, ${colors.red_bg2});
      display: flex;
      flex-direction: column;
      gap: 8px;

      .summary-label {
        font-size: 16px;
        font-weight: 600;
        opacity: 0.85;
      }

      .summary-value {
        font-size: 42px;
        font-weight: 700;
        letter-spacing: 0.5px;
      }

      .summary-meta {
        font-size: 13px;
        opacity: 0.7;
      }
    }

    .stat-section {
      border: 1px solid ${colors.border1};
      border-radius: 12px;
      padding: 24px;
      background: ${colors.bg3};
    }

    .section-header {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-bottom: 18px;

      h3 {
        font-size: 20px;
        font-weight: 700;
        color: ${colors.black1};
        margin: 0;
      }

      p {
        margin: 0;
        font-size: 14px;
        color: ${colors.text3};
      }
    }

    .stat-grid {
      display: grid;
      gap: 18px;
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      align-content: flex-start;
      justify-content: flex-start;
    }

    .stat-card {
      background: #fff;
      border: 1px solid ${colors.border2};
      border-radius: 10px;
      padding: 18px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      box-shadow: 0 6px 26px rgba(15, 35, 67, 0.08);
      cursor: pointer;
      transition: transform 0.2s ease, box-shadow 0.2s ease;

      &:hover,
      &:focus {
        transform: translateY(-4px);
        box-shadow: 0 12px 36px rgba(15, 35, 67, 0.14);
        outline: none;
      }
    }

    .stat-card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 10px;

      .stat-title {
        font-size: 16px;
        font-weight: 600;
        color: ${colors.black1};
      }
    }

    .stat-count {
      font-size: 36px;
      font-weight: 700;
      color: ${colors.red};
      line-height: 1.1;
    }

    .stat-meta {
      font-size: 13px;
      color: ${colors.text3};
    }

    .agent-email {
      font-size: 13px;
      color: ${colors.black2};
      word-break: break-word;
    }

    .status-pill {
      border-radius: 16px;
      padding: 4px 10px;
      font-size: 12px;
      font-weight: 600;
      text-transform: capitalize;
      background: ${colors.border2};
      color: ${colors.black2};

      &.status-enabled,
      &.status-active {
        background: rgba(61, 199, 125, 0.15);
        color: ${colors.red};
      }

      &.status-disabled,
      &.status-inactive {
        background: rgba(255, 107, 107, 0.18);
        color: #ff6b6b;
      }

      &.status-unknown {
        background: rgba(33, 150, 243, 0.16);
        color: #1976d2;
      }
    }

    .empty-state {
      padding: 18px;
      border-radius: 8px;
      background: ${colors.bg2};
      border: 1px dashed ${colors.border2};
      color: ${colors.text3};
      font-size: 14px;
      text-align: center;
    }

    .loading-state {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 180px;
    }

    @media (max-width: 767px) {
      .dashboard-area {
        padding: 40px 0;
      }

      .dashboard-card {
        padding: 20px;
      }

      .stat-grid {
        grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      }

      .stat-count {
        font-size: 28px;
      }
    }
  }
`;
